import { DestinationItem } from '@tableau/nested-project-explorer';
import { useEffect, useState } from 'react';

import { DestinationProjectMapper } from '~src/projects/models/mappers/DestinationProjectMapper';

import { SliceableHelper } from '../../httpClient/utils/SliceableHelper';
import { DestinationProjects } from '../../projects/resources/DestinationProjects';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';

export function useProjects() {
  const [projects, setProjects] = useState<DestinationItem[]>(null);
  useEffect(() => {
    getAllProjects().then(projects => {
      setProjects(projects);
    });
  }, []); // No dependencies, so empty array to prevent re-renders
  return projects;
}

export function getSiteName(): string {
  return getSessionManagementServiceInstance().sessionSiteName();
}

export function getInitialProject(projects: DestinationItem[], projectId: string) {
  if (!projects) {
    return null;
  }
  if (projectId) {
    return projects.find(project => project.id === projectId);
  } else {
    return getDefaultProject(projects);
  }
}

function getDefaultProject(projects: DestinationItem[]): DestinationItem {
  let validProjectWithLowestId: DestinationItem | null = null;
  projects.forEach(project => {
    if (project.status === 'valid') {
      if (!validProjectWithLowestId || (validProjectWithLowestId && Number(project.id) < Number(validProjectWithLowestId.id))) {
        validProjectWithLowestId = project;
      }
    }
  });
  return validProjectWithLowestId;
}

function getAllProjects(): Promise<DestinationItem[]> {
  const contentType = 'project';
  const itemIds: string[] = [];
  const query = '';
  // Ideally this query could be replaced by the newer implementation in `ProjectTreeService`
  const projectsQuery = DestinationProjects.getQueryForSpecificSourceContentAndMatchText(contentType, itemIds, query);
  return SliceableHelper.fetchAll(projectsQuery).then(projects => {
    const destinationProjects = DestinationProjectMapper.map(projects.items);
    return destinationProjects;
  });
}
